import { LegalLayout } from "@/components/LegalLayout";
import { BarChart3, ShieldCheck, Clock, Eye, RotateCcw } from "lucide-react";

const stats = [
  { label: "Verified sellers", value: "100%", note: "KYC-checked before going live", icon: ShieldCheck },
  { label: "Avg. report response", value: "< 48h", note: "for valid notices", icon: Clock },
  { label: "Listings reviewed", value: "24/7", note: "automated + human moderation", icon: Eye },
  { label: "Buyer protection", value: "14-day", note: "returns on eligible items", icon: RotateCcw },
];

const sections = [
  { heading: "Content moderation", body: (
    <p>We combine automated detection with human review to identify illegal content, unsafe products and policy breaches. Actions range from listing removal to account suspension, always with a statement of reasons and a right to appeal.</p>
  ) },
  { heading: "Handling of notices", body: (
    <p>Reports submitted via our <a className="text-primary underline underline-offset-2" href="/disputes">Disputes & Reports</a> and <a className="text-primary underline underline-offset-2" href="/report-ip-violation">IP Violation</a> portals are triaged by severity. Urgent safety issues are escalated immediately.</p>
  ) },
  { heading: "Cooperation with authorities", body: (
    <p>We respond to lawful requests from regulators and law-enforcement bodies and provide points of contact under the EU Digital Services Act, the UK Online Safety Act, and — in Nigeria — the FCCPC (consumer protection) and NDPC (data protection).</p>
  ) },
  { heading: "Advertising transparency", body: (
    <p>This site may display advertising served by Google AdSense. We clearly distinguish ads from editorial and marketplace content.</p>
  ) },
];

export default function TransparencyCenter() {
  return (
    <LegalLayout
      title="Transparency Center"
      icon={BarChart3}
      testid="transparency-page"
      intro="We believe a safe marketplace must also be an open one. The Transparency Center summarises how we moderate content, enforce our policies and protect our community."
      sections={sections}
    >
      <div className="grid grid-cols-2 gap-4 mb-8">
        {stats.map(({ label, value, note, icon: Icon }) => (
          <div key={label} className="group relative overflow-hidden rounded-2xl border border-border/60 bg-card p-5 transition-shadow hover:shadow-lg" data-testid="transparency-stat">
            <div className="absolute -right-6 -top-6 h-20 w-20 rounded-full bg-primary/5 transition-transform group-hover:scale-125" aria-hidden="true" />
            <Icon className="w-5 h-5 text-primary mb-3" aria-hidden="true" />
            <div className="font-display font-black text-3xl text-foreground">{value}</div>
            <div className="font-semibold text-sm mt-1">{label}</div>
            <div className="text-xs text-muted-foreground mt-0.5">{note}</div>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground border-t border-border/60 pt-4">Figures shown are indicative programme commitments. Detailed periodic transparency reports are available to regulators on request.</p>
    </LegalLayout>
  );
}
